import script from "./TimetableSearchResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableSearchResults.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableSearchResults.vue?vue&type=style&index=0&id=532a251c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532a251c"]])

export default __exports__